import UserVerificationManager from "@components/UserVerification/UserVerificationManager";
import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import withAuthContext from "./withAuthContext";

export default withAuthContext(
  withErrorBoundary(UserVerificationManager, {
    name: "UserVerificationManager",
  }),
);
